import React from 'react';
import { MdFacebook, MdEmail } from 'react-icons/md';
import { FaInstagram, FaTiktok } from 'react-icons/fa';

interface PlatformIconProps {
  platform: string;
  size?: number;
}

const PlatformIcon: React.FC<PlatformIconProps> = ({ platform, size = 12 }) => {
  // Handle edge cases
  if (!platform || typeof platform !== 'string') {
    return null;
  }
  
  // Normalize platform string: trim whitespace and convert to uppercase
  const normalizedPlatform = platform.trim().toUpperCase();
  
  // Check if platform contains keywords (handles variations like "Instagram Business", "Facebook Page", etc.)
  if (normalizedPlatform.includes('FACEBOOK')) {
    return <MdFacebook className="text-blue-500" size={size} />;
  }
  if (normalizedPlatform.includes('INSTAGRAM')) {
    return <FaInstagram className="text-pink-500" size={size} />;
  }
  if (normalizedPlatform.includes('TIKTOK') || normalizedPlatform.includes('TIK TOK')) {
    return <FaTiktok className="text-gray-100" size={size} />;
  }
  if (normalizedPlatform.includes('EMAIL') || normalizedPlatform.includes('MAIL')) {
    return <MdEmail className="text-yellow-500" size={size} />;
  }
  
  return null;
};

export default PlatformIcon;
